<template>

  <div class="center-form">
    <form @submit.prevent="restore_password">

      <h3 class="h3 mb-3 text-white text-center">Восстановление пароля</h3>
      <div class="card" style="height: 18rem" v-if="reg_end">
        <div class="card-body">
          <h4 class="card-text" style="position: absolute;top: 25%; text-align: center">
            Инструкции по восстановлению пароля отправлены на указанный email.
          </h4>
        </div>
      </div>
      <template v-else>
        <div class="form-floating">
          <input class="form-control" required name="email" type="email" v-model="username" placeholder="Email">

          <label>Email</label>
        </div>
        <button class="w-100 btn btn-lg btn-primary mt-3" type="submit">Восстановить</button>
      </template>
      <div class="d-flex justify-content-around mt-2 text-white">
        <router-link to="/login/" class="text-white">Авторизация</router-link>
<!--        |-->
<!--        <router-link to="/registration/" class="text-white">Регистрация</router-link>-->
      </div>
    </form>
  </div>

</template>
<script>
import {UserApi} from '@/api/user'

export default {

  name: 'ForgotPassword',
  data() {
    return {
      username: "",
      reg_end: false,
    }
  },
  components: {},

  mounted: function () {
    if (localStorage.getItem('username')) this.username = localStorage.getItem('username');
  },
  methods: {
    restore_password: function (e) {
      e.preventDefault();
      let $this = this;
        UserApi.restore_password(this.username).then(response => {
          if (response.data['errors']) {
            for (let i in response.data['errors']) {
              $this.$notify({
                type: 'error',
                text: response.data['errors'][i]
              })
            }
          } else $this.reg_end = true;

        });

    }
  }
}
</script>


<style scoped lang="scss">
.center-form form{
  margin: 0 auto;
  background: var(--deep-blue);
  padding: 20px;
  border-radius: 10px;
  max-width: 360px;
}
.forget {
  display: flex;
  justify-content: space-around;
}
</style>

